"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_demi_1 = require("vue-demi");
const util_1 = require("../util");
const useHeaderHorizScroll_1 = require("../composables/useHeaderHorizScroll");
const useHeaderFixed_1 = require("../composables/useHeaderFixed");
const useViewport_1 = require("../composables/useViewport");
const useHeaderActive_1 = require("../composables/useHeaderActive");
const request_1 = tslib_1.__importDefault(require("../assets/scripts/request"));
const rateByApp_1 = require("../assets/rateByApp");
const __sfc_main = {};
__sfc_main.props = ['list', 'defaultRateCol'];
__sfc_main.setup = (__props, __ctx) => {
    const { isPreRender } = require('../util');
    const { useToast, useLang } = require('@fegobull/webapi').use;
    const { store: { cmp } } = require('@futuweb/fego-render');
    const props = __props;
    const { langText } = useLang();
    const Toast = useToast();
    const tradeIdeaRef = (0, vue_demi_1.ref)(null);
    const tradeIdeTabReal = (0, vue_demi_1.ref)(null);
    const tradeIdeTabFaker = (0, vue_demi_1.ref)(null);
    const rateColorCls = (0, rateByApp_1.useRateClsByApp)(true, props.defaultRateCol || 'reddown');
    const dataList = (0, vue_demi_1.ref)([]);
    props.list.forEach(item => {
        dataList.value.push(Object.assign(Object.assign({}, item), { miuns: false, rate: '---' }));
    });
    const { shouldScroll, scrollNavToHorizCenter } = (0, useHeaderHorizScroll_1.useHeaderHorizScroll)({
        tradeIdeaRef,
        props
    });
    const { current } = (0, useHeaderActive_1.useHeaderActive)({
        tradeIdeaRef,
        props
    }, {
        onItemRenderChange: () => {
            scrollNavToHorizCenter();
        }
    });
    const { viewportWidth } = (0, useViewport_1.useViewport)();
    (0, useHeaderFixed_1.useHeaderFixed)({
        tradeIdeaRef
    });
    const clickMe = ({ target }) => {
        if (!target) {
            return;
        }
        const vm = cmp.getVmById(target);
        if (!vm) {
            return;
        }
        // 偏移量
        const offset = 0 - (tradeIdeTabReal.value.offsetHeight || 0);
        try {
            (0, util_1.scrollToElement)(vm.$el, {
                offset
            });
        }
        catch (err) {
            console.error('=======clickMe-err=======', err);
        }
    };
    // 当前激活标题发生变化
    (0, vue_demi_1.watch)(() => current.value || shouldScroll.value, () => {
        if (isPreRender()) {
            return;
        }
        // 横向滚动到当前激活标题
        scrollNavToHorizCenter();
    }, {
        immediate: true
    });
    // 视口变化
    (0, vue_demi_1.watch)(() => viewportWidth.value, () => {
        (0, vue_demi_1.nextTick)(() => {
            // 更新下划线
            if (isPreRender()) {
                return;
            }
            // 变更 header-real 的 max-width 值，否则 fixed 时会超出 750
            const tradeIdeaTab = tradeIdeaRef.value;
            const tradeIdeaTabRealHeader = tradeIdeTabReal.value;
            const maxWidth = `${tradeIdeaTab.getBoundingClientRect().width}px`;
            tradeIdeaTabRealHeader.style.maxWidth = maxWidth;
        });
    }, {
        immediate: true
    });
    //获取股票实时价格
    const getStockPrice = async () => {
        const HUNDRED = 100;
        const FIXED_NUM = 2;
        const PRICE_UNIT = 1e9;
        const stockIds = props.list.map(item => item.stockId).filter(item => item);
        if (!stockIds.length) {
            Toast.msg('参数异常');
            return;
        }
        const res = await request_1.default.getStockPrice({
            stockIds: stockIds.join(',')
        });
        const retMap = {};
        (res || []).forEach(item => {
            const { currentPrice, lastClosePrice } = item;
            // 涨跌幅 = (当前价格 - 历史收盘价) / 历史收盘价
            const quoteChangeNum = Number(lastClosePrice) ? (currentPrice - lastClosePrice) / lastClosePrice : 0;
            const minus = currentPrice - lastClosePrice < 0;
            let rate = '---';
            if (Number(lastClosePrice)) {
                rate = minus ? `${(quoteChangeNum * HUNDRED).toFixed(FIXED_NUM)}%` : `+${(quoteChangeNum * HUNDRED).toFixed(FIXED_NUM)}%`;
            }
            retMap[item.stockId] = {
                price: currentPrice ? currentPrice / PRICE_UNIT : 0,
                //实时价格
                minus,
                rate
            };
        });
        dataList.value.forEach(item => {
            if (retMap[item.stockId]) {
                item.rate = retMap[item.stockId].rate;
                item.minus = retMap[item.stockId].minus;
            }
        });
    };
    (0, vue_demi_1.onMounted)(async () => {
        await getStockPrice();
    });
    return {
        langText,
        tradeIdeaRef,
        tradeIdeTabReal,
        tradeIdeTabFaker,
        rateColorCls,
        dataList,
        shouldScroll,
        current,
        clickMe
    };
};
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,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